module.exports = __webpack_public_path__ + "static/dtto_cover-47606e5a634741deec39d4ef43bca791.jpg";